import { render, staticRenderFns } from "./Toma_store.vue?vue&type=template&id=ab5ababa"
import script from "./Toma_store.vue?vue&type=script&lang=js"
export * from "./Toma_store.vue?vue&type=script&lang=js"
import style0 from "./Toma_store.vue?vue&type=style&index=0&id=ab5ababa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports